// Generated by scripts/build-ui-icons.mjs.
export { UserFocus as default } from "../ui/glyphs-8";
